import { LocalStorageKeys } from "Utils/Storage/LocalStorage/LocalStorageKeys";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "Utils/Storage/LocalStorage/SecureLocalStorage";

/**
 * Stores campaign ID for a transaction in localStorage
 */
export const storeCampaignForTransaction = (
  transactionId: string,
  campaignCode: string,
): void => {
  try {
    const campaigns = getStoredCampaigns();
    campaigns[transactionId] = campaignCode;
    setLocalStorageItem(
      LocalStorageKeys.CampaignTransactions,
      JSON.stringify(campaigns),
    );
  } catch (error) {
    console.warn("Failed to store campaign data:", error);
  }
};

/**
 * Gets all stored campaigns from localStorage
 */
export const getStoredCampaigns = (): Record<string, string> => {
  try {
    const stored = getLocalStorageItem(LocalStorageKeys.CampaignTransactions);
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.warn("Failed to retrieve campaign data:", error);
    return {};
  }
};

/**
 * Gets campaign ID for a specific transaction
 */
export const getCampaignForTransaction = (
  transactionId: string,
): string | null => {
  const campaigns = getStoredCampaigns();
  return campaigns[transactionId] || null;
};
